import DotProp from 'dot-prop'

class Preferences {
    static _preferencesKey = "prefs"

    static getValue(toolKey, itemKey, actionKey, def) {
        if (!toolKey || !itemKey) {
            return def
        }

        const prefs = Preferences._getPreferencesObject()

        return DotProp.get(
            prefs,
            Preferences._getPreferencesKey(toolKey, itemKey, actionKey),
            def
        )
    }

    static setValue(toolKey, itemKey, actionKey, value) {
        if (!toolKey || !itemKey) {
            return
        }

        const prefs = Preferences._getPreferencesObject()

        DotProp.set(
            prefs,
            Preferences._getPreferencesKey(toolKey, itemKey, actionKey),
            value
        )

        Preferences._setPreferencesObject(prefs)
    }

    static getDefaults() {
        return {
            "focus": false,
        }
    }
    static GlobalPreferencesKey = "/"
    static getGlobalValue(settingsKey, actionKey) {
        const defs = Preferences.getDefaults()
        if (defs.hasOwnProperty(settingsKey)) {
            return Preferences.getValue(Preferences.GlobalPreferencesKey, settingsKey, actionKey, defs[settingsKey])
        }
    }
    static setGlobalValue(settingsKey, actionKey, value) {
        const defs = Preferences.getDefaults()
        if (defs.hasOwnProperty(settingsKey)) {
            Preferences.setValue(Preferences.GlobalPreferencesKey, settingsKey, actionKey, value)
        }
    }

    static _getPreferencesKey(toolKey, itemKey, actionKey) {
        if (typeof toolKey === 'object') {
            toolKey = toolKey.link
        }
        if (typeof toolKey === 'string' && !toolKey.startsWith('/')) {
            toolKey = '/' + toolKey
        }
        const keys = [toolKey, itemKey]
        if (actionKey) {
            keys.push(actionKey)
        }
        return keys.join('.')
    }

    static _getPreferencesObject() {
        try {
            const prefs = JSON.parse(localStorage.getItem(Preferences._preferencesKey))
            if (prefs) {
                return prefs
            }
        }
        catch(e) {}
        return {}
    }
    static _setPreferencesObject(obj) {
        try {
            localStorage.setItem(Preferences._preferencesKey, JSON.stringify(obj))
        }
        catch(e) {}
    }

    static resetAll() {
        try {
            localStorage.removeItem(Preferences._preferencesKey)
        }
        catch(e) {}
    }
}

export default Preferences
